jQuery(function($){
  // external js: isotope.pkgd.js

  // init Isotope
  var $grid = $('.grid').isotope({
    itemSelector: '.alm-item',
    layoutMode: 'fitRows',
    transitionDuration: 0,
    transformsEnabled: false,
    // only opacity for reveal/hide transition
    hiddenStyle: {
      opacity: 0
    },
    visibleStyle: {
      opacity: 1
    }
  });

  // store filter for each group
  var filters = {};

  $('.filters').on( 'change', function( event ) {
    var $select = $( event.target );
    // get group key
    var filterGroup = $select.attr('value-group');
    // set filter for group
    filters[ filterGroup ] = event.target.value;
    // combine filters
    var filterValue = concatValues( filters );
    // set filter for Isotope
    $grid.isotope({ filter: filterValue });
  });

  // flatten object by concatting values
  function concatValues( obj ) {
    var value = '';
    for ( var prop in obj ) {
      value += obj[ prop ];
    }
    return value;
  }
});